// extracted by mini-css-extract-plugin
export var deleteModal = "_f9-0";